/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_EditInputs */

const vi_tea_grade_edit = /** @type {(inputs: Tea_Grade_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phân loại`)
};

/**

* @param {Tea_Grade_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_edit = /** @type {((inputs?: Tea_Grade_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_edit(inputs)
});